// src/pdf/spImages.js
import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * List images for returns_v2 doc.
 * Expects: row.storage.folderId exists.
 */
export async function listImagesForReturnsV2(row) {
  const folderId = row?.storage?.folderId;
  if (!folderId) return [];
  const fns = getFunctions(undefined, "europe-west2");
  const list = httpsCallable(fns, "spListImages");
  const { data } = await list({ folderItemId: folderId });
  return data?.images || [];
}

/**
 * Get image as data URL for jsPDF (base64).
 * Uses your callable spGetImageData: { mime, base64 }
 */
export async function getImageDataUrl(itemId) {
  const fns = getFunctions(undefined, "europe-west2");
  const getData = httpsCallable(fns, "spGetImageData");
  const { data } = await getData({ itemId });
  if (!data?.mime || !data?.base64) return null;
  return `data:${data.mime};base64,${data.base64}`;
}

/**
 * Quick thumbnails for viewer (takes first N images and converts to data URLs).
 */
export async function getThumbsForReturnsV2({ returnsId, storage, type, take = 6 }) {
  if (!storage?.folderId) return [];
  const imgs = await listImagesForReturnsV2({ storage });
  const chosen = (imgs || []).slice(0, take);

  const out = [];
  for (const img of chosen) {
    try {
      const dataUrl = await getImageDataUrl(img.id);
      if (!dataUrl) continue;
      out.push({
        id: img.id,
        name: img.name,
        thumbUrl: dataUrl,
        webUrl: img.webUrl || dataUrl,
      });
    } catch {
      // ignore
    }
  }
  return out;
}
